// extracted by mini-css-extract-plugin
module.exports = {"toolbar":"PlayerPage_toolbar__2LlRG","buttons":"PlayerPage_buttons__20HcV","save":"PlayerPage_save__XT0s3","delete":"PlayerPage_delete__2a5Ff","back":"PlayerPage_back__22JTl"};